import React from "react";

const customers = [
  {
    logo: "https://logowik.com/content/uploads/images/hindustan-zinc7644.jpg",
  },
  {
    logo: "https://th.bing.com/th/id/OIP.1eUhW6G5JwD3LXbKO59hPAHaE8?rs=1&pid=ImgDetMain",
  },
  {
    logo: "https://www.associated-furnaces.com/images/product/aluminium/big/secondary_smelthers.jpg",
  },
  {
    logo: "https://www.buildersmart.in/media/catalog/product/cache/1/image/9df78eab33525d08d6e5fb8d27136e95/a/m/ambuja_opc.jpg",
  },
  {
    logo: "https://th.bing.com/th/id/OIP.nXw7Txg45OFChyijpQnEEwHaF4?rs=1&pid=ImgDetMain",
  },
  {
    logo: "https://th.bing.com/th/id/OIP.aG_GCTElcww2F3wR___7vAHaEH?rs=1&pid=ImgDetMain",
  },
  {
    logo: "https://digest.myhq.in/wp-content/uploads/2023/04/Thermax-1536x1024.png",
  },
  {
    logo: "https://www.synergytransformers.com/wp-content/uploads/2023/02/Mahakaushal-Sugar-Power-Industries-LTD.png",
  },
];

const containerStyle = {
  display: "grid",
  gridTemplateColumns: "1fr",
  gap: "20px",
  padding: "20px",
};

const itemStyle = {
  backgroundColor: "#f8f9fa",
  padding: "20px",
  borderRadius: "8px",
  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
};

const imageStyle = {
  width: "100%",
  height: "auto",
  borderRadius: "8px",
};

const gridContainerStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))",
  gap: "20px",
  padding: "20px",
  justifyContent: "center",
  backgroundColor: "#F5F5DC", // Latte background
};

const cardStyle = {
  backgroundColor: "#FFF8DC", // Cornsilk color
  borderRadius: "10px",
  padding: "10px",
  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "150px",
};

const logoImageStyle = {
  maxWidth: "100%",
  maxHeight: "100%",
  objectFit: "contain",
};

function HomePageContent() {
  return (
    <div style={containerStyle}>
      <div style={itemStyle}>
        <h1>Our Strengths</h1>
        <ul>
          <li>In-depth market knowledge through association with various Power, Sugar, Paper, Cement & Steel projects.</li>
          <li>Familiarity with various practices and standards.</li>
          <li>Understanding of requirements from inspection agencies and consulting organizations.</li>
          <li>Capability to troubleshoot, analyze, and resolve field problems in challenging sites.</li>
        </ul>
      </div>

      <div style={itemStyle}>
        <h1>Infrastructure</h1>
        <p>
          Modern Boilers & Pressure Equipments boasts advanced infrastructure, enhancing the quality of our work. Our infrastructure is divided into departments like quality control, development, production, and human resources, all dedicated to the company's and clients' welfare.
        </p>
        <p>
          Our team of highly qualified and experienced Engineers/Site Supervisors provides exceptional construction outputs. Our contract partners and consultants, Modern Engineers & Erectors (MEES), contribute significantly to our successful project realization.
        </p>
      </div>

      <div style={itemStyle}>
        <h1>Organization Chart</h1>
        <img src="/organisation.jpg" alt="Organization Chart" style={imageStyle} />
      </div>

      <div style={itemStyle}>
        <h1>Our Working System</h1>
        <p>
          Firstly, on receipt of a Tender Inquiry, we highlight the due date of opening and serially arrange inquiries by their respective due dates. All incoming inquiries are registered. The scope of work and other requirements of each inquiry item are thoroughly studied, and the cost of the items is worked out accordingly. Quotations are dispatched well in advance of the due date for economic efficiency.
        </p>
        <p>
          On the due date, we attend the tender openings and prepare a comparative statement to check market trends. The Purchase Order received from customers is entered into our order book, and a PO-wise file is maintained. The serial number of the PO is controlled from the order book. An acknowledgment of the order is sent to the purchase officer.
        </p>
        <p>
          The Purchase Order is checked against the quotation for items, quantity, rates, delivery, and other terms & conditions, including taxes. Any shortage of drawings and specifications is listed, and a request is sent to the customer for the arrangement of the missing drawings.
        </p>
        <p>
          We maintain a stock register for customer-supplied material with proper coding of individual sections and Test Certificate (T.C.) numbers. The site engineer studies the technical requirements of each drawing and proceeds accordingly. Internal QC checks the jobs at different stages (marking, fit-up, welding, grinding, and finishing). A record of internal reports is maintained in the register along with challan and bill numbers.
        </p>
        <p>
          Finally, the QC in-charge physically checks the job for painting, identification, and aesthetic appearance.
        </p>
      </div>

      <div style={itemStyle}>
        <h1>Our Customers</h1>
        <div style={gridContainerStyle}>
          {customers.map((customer, index) => (
            <div key={index} style={cardStyle}>
              <img src={customer.logo} alt="Customer Logo" style={logoImageStyle} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default HomePageContent;
